import { Controller } from "@hotwired/stimulus";

// One min / max pair for a range stored in a column pair per unit (membership age in months or in days).
// Picking a unit points the inputs at that unit's columns; each input's `data-unit-names` maps unit => field
// name. The partial posts every column blank first, so the columns of the unit not chosen clear on save.
export default class extends Controller {
  static targets = ["unit", "input"];

  select(event) {
    // The min / max switches' change events bubble through here too.
    if (event.target !== this.unitTarget) return;

    const unit = this.unitTarget.value;
    this.inputTargets.forEach((input) => {
      const name = JSON.parse(input.dataset.unitNames)[unit];
      if (name) input.name = name;
    });
  }
}
